import React from 'react';
import 'component/page/detail/DetailsPage.scss';
import { connect } from 'react-redux';
import { PageContentStatus } from 'core/type/PageContentStatus';
import { mapDispatchToProps, mapStateToProps } from 'component/page/detail/PackageOptions/PackageOptionsWrapper.selectors';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesPackageOptionSeenEventActivitiesFieldsV2 } from '@agoda/analytics-messages-definition-activities/events.split';
import { ActivitiesPackageOptionSeenEventActivitiesManifestV2 } from '@agoda/analytics-messages-definition-activities/manifest/events';
import { useLocation } from 'react-router-dom';
import { fetchAvailability } from 'component/page/detail/store/availabilityIndex';
import { InView } from 'react-intersection-observer';
import { Typography } from '@drone-js/core';
import { PackageOptionsModularProvider } from 'component/page/detail/PackageOptions/PackageOptionsModularContext';
import { PackageOptionsContentConfigMap, Props } from 'component/page/detail/PackageOptions/PackageOptionsModular.types';
import DateChipContainer from 'component/page/detail/DateChipContainer/DateChipContainer';
import PackageOptionContainer from 'component/page/detail/PackageOptions/PackageOptionContainer/PackageOptionContainer';

const PackageOptionsModular: React.FC<Props> = (props) => {
    const location = useLocation();
    const { contentStatus, earliestAvailabilityDate, validAvailableOffers, validUnavailableOffers, activityTokenFromDetail, isContinueYourBookingFeature } = props;
    const locationSearch = location.search;
    const allValidOffers = validAvailableOffers.concat(validUnavailableOffers);
    const prevEarliestAvailabilityDate = React.useRef<Date | undefined>(undefined);
    const { isHideOfferCalendar, titleFontSize, isChipOfferOption, isExpandOfferCard } = PackageOptionsContentConfigMap[props.variant];

    const onSeen = (inView: boolean) => {
        if (inView && contentStatus === PageContentStatus.Success) {
            trackElementEvent<ActivitiesPackageOptionSeenEventActivitiesFieldsV2>(
                ActivitiesPackageOptionSeenEventActivitiesManifestV2.ids,
                { action_element_count: validAvailableOffers.length, unavailable_offer_count: validUnavailableOffers.length },
                { activity_id: props.activityId, action_element_value: allValidOffers.length.toString() },
            );
        }
    };

    React.useEffect(() => {
        if (prevEarliestAvailabilityDate.current !== earliestAvailabilityDate) {
            !isContinueYourBookingFeature && props.setSelectedDateFromQueryParams(locationSearch);
            if (activityTokenFromDetail) {
                fetchAvailability(activityTokenFromDetail, { excludePassengers: true });
            }
        }
        prevEarliestAvailabilityDate.current = earliestAvailabilityDate;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locationSearch, earliestAvailabilityDate]);

    return (
        <InView onChange={onSeen} triggerOnce={true} threshold={0.75}>
            <Typography variant={titleFontSize} tag="h2" tabIndex={0}>
                {props.cms[238726]}
            </Typography>
            <DateChipContainer />
            <PackageOptionsModularProvider isHideOfferCalendar={isHideOfferCalendar} isChipOfferOption={isChipOfferOption} isExpandOfferCard={isExpandOfferCard}>
                <PackageOptionContainer activity={props.activity} isLoading={props.isLoading} isLoaded={props.isLoaded} />
            </PackageOptionsModularProvider>
        </InView>
    );
};
PackageOptionsModular.displayName = 'PackageOptionsModular';

export default connect(mapStateToProps, mapDispatchToProps)(PackageOptionsModular);
